import { useGetLessonData } from '../TeacherCourseLessonsHooks';
import { flatten, unique } from '../../../../../../utils/ArrayUtils';
import TeacherCourseAssignLessonsAction from './TeacherCourseAssignLessonsAction';
import './TeacherCoursesMultiSelectionActions.scss';
import { useTeacherCourses } from '../../../../context/TeacherCourseContextProvider';
import LessonsAddToGroupPlay from '../../../../../lessons/lessonactions/lesson-multi-selection-actions/LessonsAddToGroupPlay';
import { filterUndefined } from '../../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  selectedLessonIds: [],
  excludeLessonTypes: [],
  includeLessonTypes: [],
};

// eslint-disable-next-line arrow-body-style
const TeacherCoursesMultiSelectionActions = (p) => {
  const {
    selectedLessonIds,
    excludeLessonTypes,
    includeLessonTypes,
  } = { ...defaultProps, ...filterUndefined(p) };
  const {
    filteredLessonData,
  } = useGetLessonData({
    excludeLessonTypes,
    includeLessonTypes,
  });

  const lessons = filteredLessonData.lessons || [];
  const allLessons = unique(flatten(lessons.map((subjectWithLessons) => subjectWithLessons.lessons)), 'id') || [];

  const { teacherCourseDomain } = useTeacherCourses();
  const { selectedDates } = teacherCourseDomain.domainData;

  return (
    <div className='teacher-courses-multi-selection-actions'>
      <LessonsAddToGroupPlay
        lessons={allLessons}
        selectedLessonIds={selectedLessonIds}
        // onSaveSuccess={() => {
        //   teacherCourseDomain.updateLessonsData([...lessons], [...included]);
        // }}
      />
      <TeacherCourseAssignLessonsAction
        lessons={allLessons}
        selectedLessonIds={selectedLessonIds}
        selectedDates={selectedDates}
      />
    </div>
  );
};

export default TeacherCoursesMultiSelectionActions;
